import React, { FC, HTMLAttributes, useCallback } from 'react';
import BasicModal from 'components/modals/BasicModal/BasicModal';
import { Button, Heading } from 'components/ui';
import classNames from 'classnames';
import { Field, Form } from 'react-final-form';
import { SelectWithRolesFieldsWrapper } from 'components/forms';
import { useDispatch, useSelector } from 'react-redux';
import { useDispatchRequest, useQuery } from '@redux-requests/react';
import { toggleAddNewScopesModal } from 'modules/layout/store/actions';
import { addNewScopes } from 'modules/layout/store/actions/addNewScopesAction';
import { RootState } from 'store/rootReducer';
import { useParams } from 'react-router-dom';
import styles from './AddNewScopeModal.module.scss';
import { AppsConstants } from 'modules/userApps/store/constants';
import { t } from 'utils';

export interface IAddNewScopeModal extends HTMLAttributes<HTMLDivElement> {}

const AddNewScopeModal: FC<IAddNewScopeModal> = (props) => {
  const { className } = props;
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const disaptchRequest = useDispatchRequest();
  const isOpen = useSelector((state: RootState) => state.layout.addNewScopeModal);
  const {
    data: { roles },
  } = useQuery({ type: AppsConstants.APP, requestKey: id });
  const rootClassName = classNames(styles.root, className);

  const handleColseModal = useCallback(() => {
    dispatch(toggleAddNewScopesModal(false));
  }, [dispatch]);

  const handleScopesSubmit = useCallback(
    async ({ roles = [] }) => {
      const { data } = await disaptchRequest(addNewScopes({ roles, id }));
      if (data) {
        handleColseModal();
      }
    },
    [disaptchRequest, handleColseModal, id]
  );

  return (
    <BasicModal className={rootClassName} open={isOpen} onClose={handleColseModal}>
      <Form
        initialValues={{ roles }}
        onSubmit={handleScopesSubmit}
        render={({ handleSubmit, valid, pristine }) => (
          <form onSubmit={handleSubmit}>
            <Heading className={'mb-2'} icon={'code-branch'}>
              {t('add.new.scope')}
            </Heading>
            <Field
              className={'mb-4'}
              name='roles'
              validate={(value = '') => (value.length ? undefined : t('errors.required'))}
              dropdownPlaceholder='form.field.label.app.scope'
              component={SelectWithRolesFieldsWrapper}
              hasScrollFieldgroup
              isSmallList
              addSelectedOptionInFront
              useRelativeTopElements // to prevent the dropdown and radios fields flying away from modal
            />
            <Button
              className={'mr-2'}
              inline
              type={'button'}
              variant={'secondary'}
              onClick={handleColseModal}
            >
              {t('cancel')}
            </Button>
            <Button disabled={!valid || pristine} inline>
              {t('add.scope')}
            </Button>
          </form>
        )}
      />
    </BasicModal>
  );
};

export default AddNewScopeModal;
